<template>
    <div>    
        <section class="page-section bg-light" id="listen">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-left">
                        <img src="/img/love-with-your-phone.webp" height="300px" class="rounded mx-auto d-block mr-2 mb-3"/>
                        <hr>
                        <h2 class="">
                            <b>Love with Your Phone</b> by Jono and the Raj
                        </h2>
                        <p class="mb-1 text-muted text-sm">Listen</p>
                        <a target="_blank"  href="https://open.spotify.com/artist/0ixKcZ4M7G1e9HMciAXnG7">
                            <img class="mr-2" src="img/spotify.svg" height="25px" />
                        </a>
                        <a target="_blank"  href="https://www.youtube.com/@therajloonaticproductions2574">
                            <img class="mr-2" src="img/yt.png" height="25px" />
                        </a>
                        <p class="mt-4">
                            <b>Love with Your Phone</b> is the first album by Jono and the Raj. It's an electric experimental album about love lost,
                            how we communicate in modern socety and where we are going as humanity.
                         </p>
                         <p>
                            In January of 2020, I (Raj Maitra) moved back to the Twin Cities from San Francisco, California and reached out to 
                            Jono Cowgill about producing his first album. I wanted to build a new music studio in Minneapolis and a portfolio of new music. 
                            I pitched a concept to Jono: we record the original arrangements of his songs and then I rearrange each song with a new vision. Many of the songs originally 
                            had stripped down piano and I wanted to merge the emotive vocals to dancey, hip hop and electric sound. I was experimenting with pop and jazz chord progressions
                            while pushing the level of <b>weird</b> to as far as possible without losing digestability.
                         </p>
                         <p>
                            This album took about a year to ceate and finish. At the end we released the album on all major platforms.
                          </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-0 mt-4">
                        <h3><b>Music Video</b></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 text-left"  v-for="item in items" v-bind:key="item.id">
                        <div class="mt-5">
                            <h3 class="h4 mb-2">
                                <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                    {{ item.title }}
                                </a>
                            </h3>
                        </div>
                        <div class="mt-2">
                            <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                <img v-bind:src="item.photo" async class="rounded w-90 shadow play-youtube-video lazy ">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: '',
    components: {
    },
    data: function(){
        return{
            items: [
                { 
                    title: 'Cream Puffs',  
                    id:'Sy7VqNvyaII',
                    photo:'/img/cream-puffs-video.png'
                }
            ]
        }
    }
}
</script>